var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2143_819)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2143_819)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3678 48.9457C37.5266 48.9457 48.1938 38.2784 48.1938 25.1197C48.1938 11.961 37.5266 1.2937 24.3678 1.2937C11.2091 1.2937 0.54184 11.961 0.54184 25.1197C0.54184 38.2784 11.2091 48.9457 24.3678 48.9457Z",
    fill: "#FF6900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0319 24.0329L24.1152 21.7718C23.6101 21.4787 23.0098 21.48 22.5072 21.7718C22.0046 22.0623 21.7051 22.5816 21.7051 23.1626V27.686C21.7051 28.2657 22.0046 28.7876 22.5072 29.0768C22.7591 29.2234 23.0355 29.2954 23.3106 29.2954C23.5869 29.2954 23.8633 29.2234 24.1152 29.0768L28.0319 26.8171C28.5345 26.5253 28.8353 26.0047 28.8353 25.425C28.8353 24.844 28.5345 24.3234 28.0319 24.0329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5539 19.2895C30.1772 18.9155 29.5654 18.9167 29.19 19.2959C28.816 19.6739 28.8186 20.2844 29.1965 20.6585C30.4716 21.9221 31.1734 23.6149 31.1734 25.4248C31.1734 27.2347 30.4716 28.9276 29.1965 30.1911C28.8186 30.5652 28.816 31.1758 29.19 31.555C29.379 31.7439 29.6271 31.839 29.8752 31.839C30.1207 31.839 30.3662 31.7465 30.5539 31.5601C32.1966 29.9328 33.1016 27.7527 33.1016 25.4248C33.1016 23.0956 32.1966 20.9181 30.5539 19.2895Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6587 19.2959C19.2833 18.9167 18.6728 18.9155 18.2949 19.2895C16.6521 20.9181 15.7484 23.0969 15.7484 25.4248C15.7484 27.754 16.6521 29.9328 18.2949 31.5614C18.4825 31.7465 18.728 31.839 18.9736 31.839C19.2216 31.839 19.471 31.7439 19.6587 31.555C20.034 31.1758 20.0315 30.5652 19.6523 30.1911C18.3771 28.9276 17.6766 27.2347 17.6766 25.4248C17.6766 23.6149 18.3771 21.9221 19.6523 20.6598C20.0315 20.2844 20.034 19.6739 19.6587 19.2959Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1942 15.6558C33.8176 15.2791 33.207 15.2791 32.8304 15.6558C32.4537 16.0324 32.4537 16.643 32.8304 17.0196C35.0773 19.2665 36.3151 22.2512 36.3151 25.4249C36.3151 28.5986 35.0773 31.5847 32.8304 33.8316C32.4537 34.2082 32.4537 34.8188 32.8304 35.1954C33.0193 35.3831 33.2661 35.4769 33.5129 35.4769C33.7597 35.4769 34.0065 35.3831 34.1942 35.1954C36.8049 32.5834 38.2432 29.1128 38.2432 25.4249C38.2432 21.7358 36.8049 18.2664 34.1942 15.6558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5349 25.4249C12.5349 22.2512 13.7715 19.2652 16.0184 17.0183C16.395 16.6417 16.395 16.0324 16.0184 15.6558C15.6418 15.2791 15.0325 15.2791 14.6558 15.6558C12.0452 18.2664 10.6068 21.7358 10.6068 25.4249C10.6068 29.1128 12.0452 32.5834 14.6558 35.1954C14.8435 35.3831 15.0903 35.4769 15.3371 35.4769C15.5839 35.4769 15.8307 35.3831 16.0184 35.1954C16.395 34.8188 16.395 34.2082 16.0184 33.8316C13.7715 31.5847 12.5349 28.5986 12.5349 25.4249Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2143_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 49.7,
    fill: "white",
    transform: "translate(0.5 0.169922)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2143_819"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 49.7143,
    fill: "white",
    transform: "translate(0.5 0.162842)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon1);
export default __webpack_public_path__ + "static/media/icon1.b3fe774493b49d554f0956ee883e2405.svg";
export { ForwardRef as ReactComponent };